import React from 'react'

function Gform() {
  return (
    <div style={{background: "linear-gradient(to right, #1e2464, #090a1f)"}}>
    <div></div>
      {/* <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe4jsiKoE08rJxT_varyC_xYs1CtNCSzJKBfu544HKdJ5xlfA/viewform" width="100%" height="1541" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}
      
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe4jsiKoE08rJxT_varyC_xYs1CtNCSzJKBfu544HKdJ5xlfA/viewform?embedded=true" width="100%" height="2216" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>


    </div>
  )
}

export default Gform
